import React from 'react';

import * as S from './AmenitiesList.styles';

import AmenitiesIconSelector from '../../../../../shared/components/AmenitiesIconSelector';
import {defaultTheme} from '@ibibo/build-theme';

const AmenitiesList = ({list}: {list: Array<string>}) => {
  const hasMore = list.length > 2;

  if (!list.length) return null;

  return (
    <>
      {list.map((item, index) => {
        if (index < 2) {
          return (
            <S.IconWrapperDiv key={index + item} padding="0 1rem 0 0">
              <AmenitiesIconSelector
                name={item}
                height="1.5rem"
                width="1.5rem"
                fill={defaultTheme.colors.grey.base}
              />
              <S.TextWrapper>{item}</S.TextWrapper>
            </S.IconWrapperDiv>
          );
        }
      })}
      {(hasMore && (
        <S.HoverTargetWrapperDiv>
          <S.BlueTextSpan>+ more</S.BlueTextSpan>
          <S.HiddenDropdownWrapperDiv top={'1rem'}>
            <S.TopDiv>
              <S.ListDropDownWrapper>
                <li>
                  <S.IconWrapperDiv>
                    <S.TextWrapper color={defaultTheme.colors.blue.base}>Amenities</S.TextWrapper>
                  </S.IconWrapperDiv>
                </li>
                {list.map((item, index) => {
                  if (index > 2 && index < 8) {
                    return (
                      <li key={index + item}>
                        <S.IconWrapperDiv>
                          <AmenitiesIconSelector
                            styleProps={{
                              height: '1.5rem',
                              width: '1.5rem',
                              fill: defaultTheme.colors.grey.base
                            }}
                            name={item}
                          />
                          <S.TextWrapper>{item}</S.TextWrapper>
                        </S.IconWrapperDiv>
                      </li>
                    );
                  }
                })}
              </S.ListDropDownWrapper>
              <S.TipPositioning />
            </S.TopDiv>
          </S.HiddenDropdownWrapperDiv>
        </S.HoverTargetWrapperDiv>
      )) ||
        ''}
    </>
  );
};

export default AmenitiesList;
